<template>
  <app-page-section
    class="bg-primary-950 rounded-lg px-8 py-8 text-white md:py-24"
    :subtitle="{
      tag: 'p',
      text: 'Pollen réinvente la formation professionnelle aux côtés des meilleurs experts du marché, en poste dans les entreprises les plus innovantes. Notre organisme de formation est certifié Qualiopi, sur le périmètre des actions de formation. Vous pouvez demander à financer votre prochaine formation Pollen grâce au budget OPCO.',
    }"
    :title="{
      tag: 'h3',
      text: 'Pollen, un organisme de formation professionnelle et continue',
    }"
  >
    <template #prepend>
      <div>
        <app-image
          alt="Qualiopi logo"
          class="mx-auto"
          src="/images/qualiopi_logo.svg"
        />
        <p class="mt-4 max-w-[600px] text-balance text-center text-sm">
          <a class="underline" :href="qualiopiCertificate" target="_blank"
            >La certification qualité</a
          >
          a été délivrée au titre de la catégorie d’actions suivante :
          <strong>ACTIONS DE FORMATION</strong>.
        </p>
      </div>
    </template>

    <template #append>
      <app-button
        class="w-full sm:w-auto"
        color="light"
        size="xl"
        to="/getting-financed"
        variant="outlined"
      >
        En savoir plus
      </app-button>
    </template>
  </app-page-section>
</template>

<script setup lang="ts">
const {
  public: {
    documents: { qualiopiCertificate },
  },
} = useRuntimeConfig();
</script>
